<template>
  <div class="character">
    <v-card :img="$classImages.bannerImages[bdoClass]" color="rgba(25,25,25,1)">
      <v-row>
        <v-col cols="12" sm="7">
          <div class="pl-8">
            <v-card-title
              class="white--text font-weight-bold text-uppercase text-md-h2 text-h3 d-inline-block text-truncate"
              style="max-width: 80vw;"
            >{{familyName}}</v-card-title>
            <v-card-text
              class="white--text font-weight-bold text-uppercase text-md-h3 text-h4 d-inline-block text-truncate"
              style="max-width: 80vw;"
            >{{characterName}}</v-card-text>
            <v-card-subtitle
              class="white--text font-weight-medium text-md-h4 text-h4 pt-0 d-inline-block text-truncate"
              style="max-width: 80vw;"
            >
              <v-icon color="white">mdi-shield</v-icon>
              {{guildName}}
            </v-card-subtitle>
            <v-row class="pl-4">
              <v-card-subtitle
                class="white--text font-weight-medium text-md-h4 text-h4 pt-0"
                style="max-width: 80vw;"
              >
                <span>Level</span>
                {{level}}
                <v-icon class="hidden-md-and-up" color="white" size="1rem">icon-{{bdoClass}}</v-icon>
              </v-card-subtitle>
            </v-row>
          </div>
        </v-col>
        <v-col cols="12" sm="5" class="d-flex align-center justify-end">
          <v-icon class="hidden-sm-and-down" color="white" size="6rem">icon-{{bdoClass}}</v-icon>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "UserHeaderDesktop",
  props: {
    familyName: { type: String },
    characterName: { type: String },
    bdoClass: { type: String },
    level: { type: String },
    guildName: { type: String }
  }
};
</script>

<style scoped>
</style>